import { render, staticRenderFns } from "./MainInfo.vue?vue&type=template&id=3c9078db&scoped=true&"
import script from "./MainInfo.vue?vue&type=script&lang=ts&"
export * from "./MainInfo.vue?vue&type=script&lang=ts&"
import style0 from "./MainInfo.vue?vue&type=style&index=0&id=3c9078db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9078db",
  null
  
)

export default component.exports